import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/Austin.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Mobile App Development for Tech Transformation & Digital Expansion
            </h2>
            <p>
              What’s your mobile app development goal? Increase visibility,
              enhance user engagement, sell more, or become a market leader?
              With diversely demonstrated development expertise, business
              acumen, and a novel tech stack, our mobile app development company
              in Austin comprehensively commands all necessary components that
              make an app thrive.
            </p>
            <p>
              Our refined process transforms broad concepts into specific,
              user-focused solutions. With strategic planning and a kick-off
              session, we build apps that maximize user experience and ROI.
              Starting with a limited number of sprints, we prioritize key
              features for efficient development and timely delivery. How we do
              it? Let’s have a call to discuss your mobile app development
              journey.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Talk to Us
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
